import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getPaymentProduct = (state: StateScheme) => {
    return state.payment.product
}
